import { render, staticRenderFns } from "./MemberArea.vue?vue&type=template&id=09967bfc&scoped=true"
import script from "./MemberArea.vue?vue&type=script&lang=js"
export * from "./MemberArea.vue?vue&type=script&lang=js"
import style0 from "./MemberArea.vue?vue&type=style&index=0&id=09967bfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09967bfc",
  null
  
)

export default component.exports